import React from 'react';
import './CTASection.css';
import { buildCalUrl } from '../../utils/integrationTracking';

const CTASection: React.FC = () => {
  const handleCalClick = () => {
    const finalUrl = buildCalUrl('https://cal.com/pedrobettencourt-crafteer');
    window.open(finalUrl, '_blank');
  };

  return (
    <section id="comecar">
      <div className="container">
        <div className="card">
          <div className="footer-cta">
            <h2 className="section-title">Pronto Para Fazer a Sua Estratégia Acontecer? </h2>
            <p className="section-sub">Fale com um especialista e veja como a sua carteira começa a mexer-se — hoje.</p>

            <div className="cta">
              <button className="btn ripple" onClick={handleCalClick}>
                Falar com especialista
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
